const pl = {
    ActiveDiscountCode: {
        delete: 'Usuń kod rabatowy',
    },
    Activation: {
        title: 'New Activation',
        stepOne: 'Step 1',
        stepTwo: 'Step 2',
        stepThree: 'Step 3',
        seeding: 'Konkurs z seedingiem',
        noSeeding: 'Konkurs bez seedingu',
    },
    ActivationTaskFieldArray: {
        type: 'Task Type',
        duration: 'Task Duration (days)',
        start: 'Start Date',
        end: 'End Date',
        to: 'to',
        day: 'day',
        days: 'days',
        otherActivations: (count: number) =>
            `There are ${count} other activations live in LOREALISTAR on this period.`,
    },
    ActivationProducts: {
        title: 'Activation Products',
    },
    ActivationProductFieldArray: {
        imageSubtext: 'JPG, PNG (Max <b>2MB</b>)',
        label: 'Product',
        delete: 'Delete',
        add: 'Add product',
        minCount: 'At least one product is required',
        ean: {
            label: 'EAN',
            required: 'EAN is required',
        },
        name: {
            label: 'Product name',
            required: 'Product name is required',
            info: 'This product name will be added to your task copy.',
        },
        image: {
            label: 'Product image',
            required: 'Image is required',
        },
        brand: {
            label: 'Brand',
            required: 'Brand is required',
        },
        size: {
            label: 'Product size',
            required: 'Size is required',
        },
        capacity: {
            label: 'Product capacity',
            required: 'Capacity is required',
        },
        price: {
            label: 'Market price (PLN)',
            required: 'Price is required',
        },
        tax: {
            label: 'Tax',
            required: 'Tax is required',
        },
        status: {
            label: 'Status',
            required: 'Status is required',
        },
        description: {
            label: 'Product description',
            required: 'Description is required',
            info: 'This product description will be added to your task copy.',
        },
    },
    ActivationProductModal: {
        title: 'Are you sure you want to <span>delete</span> this product?',
        description: "This item will be deleted immediately. You can't undo this action",
        cancel: 'Cancel',
        delete: 'Yes, delete',
    },
    ActivationDeleteModal: {
        title: 'Are you sure you want to <span>delete</span> this activation?',
        description: "This activation will be deleted immediately. You can't undo this action",
        cancel: 'Cancel',
        delete: 'Yes, delete',
    },
    ActivationRewardFieldArray: {
        name: {
            label: 'Reward Name',
            placeholder: 'Fill',
        },
        price: {
            label: 'Reward Market Value in PLN',
            placeholder: 'Fill',
        },
        taxName: {
            label: 'Vat',
            placeholder: 'Select',
        },
        tax: 'Reward Tax (11,1%) in PLN',
        image: 'Reward Picture',
        imageSubtext: 'JPG, PNG (Max <b>2MB</b>)',
        label: 'Reward',
        delete: 'Delete',
        add: 'Add reward',
        minCount: 'At least one reward is required',
    },
    ActivationStepOneForm: {
        division: {
            label: 'Division',
            placeholder: 'Select',
            error: 'Please, choose a division of your activation',
        },
        brand: {
            label: 'Brand',
            placeholder: 'Select',
            error: 'Please, choose a brand of your activation',
        },
        brands: {
            error: {
                min: 'The percentage share in the budget cannot be less than 0',
                max: 'The percentage share in the budget could not be greater than 100',
                sum: 'The sum of brand budgets must be 100%',
                noBudget: 'Enter budget for all selected brands',
                email: 'Please, type in an correct email',
                noOwner: 'Please, type in an owner email address',
            },
        },
        type: {
            label: 'Activation Type',
            placeholder: 'Select',
            error: 'Please, choose an activation type',
        },
        scenario: {
            label: 'Task Scenario',
            placeholder: 'Select',
            error: 'Please, choose a scenario for your activation',
        },
        concept: {
            label: 'Concept',
            placeholder: 'Select',
            error: 'Please, choose a concept of your activation',
        },
        community: {
            label: 'Community',
            placeholder: 'Select',
            error: 'Please, choose community type of your activation',
        },
        category: {
            label: 'Activation category',
            placeholder: 'Select',
            error: 'Please, choose a category of your activation',
        },
        club: {
            label: 'User Group/Club',
            placeholder: 'Select',
            error: 'Please, choose a group/club of your activation',
            population: (count: number) => `${count} influencer(s) selected`,
        },
        customClub: {
            placeholder: 'Fill the name of the Group/Club',
            error: 'Please, fill the name of the group/club',
            max: 'This field cannot contain more than 128 characters',
        },
        name: {
            label: 'Contest Name',
        },
        focus: {
            label: 'Unique Concept',
            placeholder: 'Fill',
            note: '(ex. Buttermelt Blush, Loveshine lipstick etc., Green ON event etc. )',
            max: 'This field cannot contain more than 128 characters',
            error: 'Please, type in an unique concept of your activation',
        },
        displayName: {
            label: 'Display Name',
            placeholder: 'Fill',
            error: 'Please, type in a display name for you activation',
            note: '(Unique activation name that will appear on the activation list, ex. NYX PM contest - Buttermelt Blushes)',
            max: 'This field cannot contain more than 128 characters',
        },
        submit: {
            label: 'Save',
        },
        nextStep: {
            label: 'Go to next step',
        },
        tasks: {
            required: 'This field is required',
            minDuration: (days: number) => `This task must last at least ${days} days`,
            maxDuration: 'Tasks cannot last longer than 32 days',
        },
        minStartDate: 'Minimal start date is',
        success: 'Activation has been successfully saved',
        error: 'Please correct errors in marked fields',
        activation: 'Activation',
        activations: {
            label: 'Activations',
            placeholder: 'Select',
            error: 'Please, choose activations you want to reactivate',
        },
        reactivation: 'Reactivation',
        weekendError: 'Activation cannot start on a weekend',
    },
    ActivationStepTwoSeedForm: {
        packages: {
            label: 'Number of packages',
            error: {
                required: 'Please, type in number of packages',
                type: 'Please, type in a correct number',
                min: 'The minimum number of packages is 1',
            },
            placeholder: 'Fill',
        },
        products: {
            label: 'Number of products in 1 package',
            name: {
                required: 'Product name is required',
            },
            code: {
                required: 'EAN is required',
            },
            sizeId: {
                required: 'Select product size',
            },
            valueGross: {
                required: 'Market Price is required',
            },
            description: {
                required: 'Product description is required',
            },
            capacity: {
                required: 'Capacity is required',
            },
            hint: 'Number of products in one package will change once a new product is added below.',
            image: {
                required: 'Product image is required',
            },
            min: 'Product is required',
        },
        type: {
            label: 'Packaging Type',
            error: 'Please, select a packaging type',
            placeholder: 'Select',
        },
        cost: {
            label: 'Cost per Package (logistics cost net) in PLN',
            hint: 'Cost Per Package =  delivery & repackaging cost (20 PLN) + insert cost (3 PLN for each insert, counted from the 2nd insert) + packaging cost <br><br> ex. for 1 package with 2 products in cardboard packaging option = 20 PLN + 3 PLN + 3,75 PLN = 26,75 PLN',
        },
        totalCost: {
            label: 'Total Cost (logistics cost net) in PLN',
        },
        included: {
            label: 'Which products should be included in 1 package?',
            placeholder:
                'Ex. NYX PM Fat Oil OR NYX PM Brow Glue at random; NYX PM Fat Oil AND NYX PM Brow Glue',
            required: 'This field is required',
        },
        submit: {
            label: 'Save',
        },
        prevStep: {
            label: 'Back',
        },
        nextStep: {
            label: 'Go to next step',
        },
        success: 'Activation has been successfully saved',
        error: 'Please correct errors in marked fields',
    },
    ActivationStepTwoNoSeedForm: {
        users: {
            label: 'Number of Users that can be Rewarded',
            placeholder: 'Fill',
            error: 'Please, type in a correct number',
            min: 'Minimal number of users is 1',
            required: 'Number of users is required',
        },
        products: {
            label: 'Number of Rewards',
            name: {
                required: 'Reward name is required',
            },
            hint: 'Number of rewards will change once a new reward is added below.',
            image: {
                required: 'Reward image is required',
            },
            taxId: {
                required: 'Select one the options',
            },
            valueGross: {
                required: 'Market Value is required',
            },
            required: 'Reward is required',
            min: 'Product is required',
        },
        taxable: {
            label: 'Taxable Reward',
            placeholder: 'Select',
            yes: 'Yes',
            no: 'No',
            required: 'Select one of the options',
        },
        submit: {
            label: 'Save',
        },
        prevStep: {
            label: 'Back',
        },
        nextStep: {
            label: 'Go to next step',
        },
        success: 'Activation has been successfully saved',
        error: 'Please correct errors in marked fields',
    },
    ActivationStepThreeForm: {
        comment: {
            label: 'Additional Comment',
            placeholder: 'Write a comment',
        },
        submit: {
            label: 'Save',
        },
        prevStep: {
            label: 'Back',
        },
        nextStep: {
            label: 'Send for verification',
        },
        success: 'Activation has been successfully saved',
    },
    ActivationPlaceholderForm: {
        division: {
            label: 'Division',
            placeholder: 'Select',
            error: 'Please, choose a division of your activation',
        },
        brand: {
            label: 'Brand',
            placeholder: 'Select',
            error: 'Please, choose a brand of your activation',
        },
        brands: {
            error: {
                min: 'The percentage share in the budget cannot be less than 0',
                max: 'The percentage share in the budget could not be greater than 100',
                sum: 'The sum of brand budgets must be 100%',
                noBudget: 'Enter budget for all selected brands',
                email: 'Please, type in an correct email',
                noOwner: 'Please, type in an owner email address',
            },
        },
        type: {
            label: 'Activation Type',
            placeholder: 'Select',
            error: 'Please, choose an activation type',
        },
        community: {
            label: 'Community',
            placeholder: 'Select',
            error: 'Please, choose community type of your activation',
        },
        scenario: {
            label: 'Task Scenario',
            placeholder: 'Select',
            error: 'Please, choose a scenario for your activation',
        },
        concept: {
            label: 'Unique Concept',
            placeholder: 'Fill',
            error: 'Please, type in an unique concept of your activation',
            note: '(ex. Buttermelt Blush, Loveshine lipstick etc., Green ON event etc. )',
        },
        focus: {
            max: 'This field cannot contain more than 128 characters',
            error: 'Please, fill the Unique Concept field',
        },
        submit: {
            label: 'Save',
        },
        activate: {
            label: 'Activate',
        },
        tasks: {
            required: 'This field is required',
            minDuration: (days: number) => `This task must last at least ${days} days`,
            maxDuration: 'Tasks cannot last longer than 32 days',
        },
        packagesSeed: {
            label: 'Number of packages',
            error: {
                required: 'Please, type in number of packages',
                type: 'Please, type in a correct number',
                min: 'The minimum number of packages is 1',
            },
            placeholder: 'Fill',
        },
        productsSeed: {
            label: 'Number of products in 1 package',
            error: 'Please, type in number of products in 1 package',
            placeholder: 'Fill',
        },
        packagesNoSeed: {
            label: 'Number of Users that can be Rewarded',
            error: {
                required: 'Number of users is required',
                type: 'Please, type in a correct number',
                min: 'Minimal number of users is 1',
            },
            placeholder: 'Fill',
        },
        productsNoSeed: {
            label: 'Number of Rewards',
            error: 'Reward is required',
            placeholder: 'Fill',
        },
        packageType: {
            label: 'Packaging Type',
            error: 'Please, select a packaging type',
            placeholder: 'Select',
        },
        taxable: {
            label: 'Taxable Reward',
            placeholder: 'Select',
            yes: 'Yes',
            no: 'No',
            required: 'Select one of the options',
        },
        minStartDate: 'Minimal start date is',
        success: 'Activation has been successfully saved',
        error: 'Please correct errors in marked fields',
        activation: 'Activation',
        weekendError: 'Activation cannot start on a weekend',
    },
    ActivationDuplicateForm: {
        type: {
            label: 'Activation Type',
            placeholder: 'Select',
            error: 'Please, choose an activation type',
        },
        scenario: {
            label: 'Task Scenario',
            placeholder: 'Select',
            error: 'Please, choose a scenario for your activation',
        },
        concept: {
            label: 'Unique Concept',
            placeholder: 'Fill',
            error: 'Please, type in an unique concept of your activation',
            note: '(ex. Buttermelt Blush, Loveshine lipstick etc., Green ON event etc. )',
        },
        focus: {
            max: 'This field cannot contain more than 128 characters',
            error: 'Please, fill the Unique Concept field',
        },
        submit: {
            label: 'Duplicate',
        },
        tasks: {
            required: 'This field is required',
            minDuration: (days: number) => `This task must last at least ${days} days`,
            maxDuration: 'Tasks cannot last longer than 32 days',
        },
        displayName: {
            label: 'Display Name',
            placeholder: 'Fill',
            error: 'Please, type in a display name for you activation',
            note: '(Unique activation name that will appear on the activation list, ex. NYX PM contest - Buttermelt Blushes)',
            max: 'This field cannot contain more than 128 characters',
        },
        minStartDate: 'Minimal start date is',
        success: 'Activation has been successfully saved',
        error: 'Please correct errors in marked fields',
        activation: 'Activation',
    },
    ActivationPlaceholderModal: {
        title: 'New activation placeholder',
        error: 'This activation placeholder can not be edited',
        deleteButton: 'Delete',
        deleteSuccess: 'Successfully deleted activation',
        deleteError: 'Failed to delete activation placeholder',
    },
    ActivationDuplicateModal: {
        title: 'Duplicate activation',
        duplicateError: 'Failed to duplicate activation. Try again later.',
    },
    ActivationDetails: {
        title: 'Dashboard',
        back: 'Back to list',
        innerTitle: 'Activation details',
        hint: 'This is your activation status. If you have any questions to your status please contact LOREALISTAR project leader.',
        edit: 'Edit',
        delete: 'Delete',
        summary: 'Download summary PDF',
        targetList: 'Download target list',
        duplicate: 'Duplicate activation',
        deleteError: 'Failed to delete the activation',
        createdAt: 'Creation Date',
        step: 'Step',
        owner: 'Activation owner (e-mail)',
        type: {
            label: 'Activation Type',
            seeding: 'Konkurs z seedingiem',
            noSeeding: 'Konkurs bez seedingu',
        },
        task: 'Task Scenario',
        focus: 'Unique concept',
        division: 'Disivsion',
        brand: 'Brand',
        club: 'User Group/Club',
        categories: 'Categories',
        packagesCount: 'Number of packages',
        productsCount: 'Number of products in 1 package',
        usersCount: 'Number of Users that can be Rewarded',
        taxableReward: 'Taxable Reward',
        tasks: 'Tasks',

        rewards: 'Rewards',
        rewardsCount: 'Number of Rewards',
        rewardPicture: 'Reward Picture',
        rewardName: 'Reward Name',
        rewardValue: 'Reward Market Value in PLN',
        rewardTax: 'Vat',
        rewardTaxValue: 'Reward Tax (11,1%)',
        products: 'Products',
        packageType: 'Packaging Type',
        productsIncluded: 'Products included in 1 package',
        packageProductCost: 'Cost per Package (logistics cost net)',
        totalProductCost: 'Total Cost (logistics cost net)',
        yes: 'Yes',
        no: 'No',
        start: 'Start Date',
        end: 'End Date',
        displayName: 'Display name',
        name: 'Contest name',
        template: 'Template',
        comment: 'Your Additional Comment',
        status: {
            draft: 'Draft',
            waiting: 'Waiting for approval',
            approvedWaiting: 'Approved waiting for copy',
            approvalCopy: 'Waiting for copy approval',
            approved: 'Approved with all documents',
            request: 'Request for improvement',
            rejected: 'Rejected',
            waitingForSeedingVerification: 'Waiting for seeding verification',
            seedingVerified: 'Seeding verified',
        },
        button: {
            download: 'Download copy',
            preview: 'Preview copy',
            complete: 'Complete task copy',
        },
        notCompleted: 'Not Completed',
        completed: 'Completed',
        deleted: 'Activation has been successfully deleted.',
        downloadError: 'Failed to download this file',
        verify: 'Verify seeding',
        poNumber: {
            label: 'PO number for logistics cost',
            placeholder: 'Fill',
            error: {
                required: 'Enter PO number',
            },
            submit: 'Save',
            success: 'PO number was saved',
        },
        poReminder: {
            button: 'PO Reminder',
            success: 'A reminder email has been sent to the owner',
            error: 'An error occurred while sending the email',
        },
        unverify: {
            label: 'Unverify seeding',
            success: 'Seeding has been successfully unverified',
            error: 'An error occurred while trying to unverify the seeding',
        },
        email: {
            button: 'Copy reminder',
            success: 'Reminder email has been sent successfully.',
            error: 'An error occurred while sending the email',
        },
        placeholder: 'Activation with placeholder status can not be displayed',
    },
    ActivationDetailsTask: {
        days: 'days',
        taskType: 'Task Type',
        taskDuration: 'Task duration',
        taskStart: 'Start Date',
        taskEnd: 'End Date',
        deadline: 'Deadline',
        import: 'Import',
        winner: 'Choose the winner',
        export: 'Export',
        delete: 'Delete',
        deleteCompleted: 'Import file has been successfully deleted.',
        importError: 'Failed to import this file. Try again later.',
        exportError: 'Failed to download this file. Try again later.',
        deleteImportError: 'Failed to delete import file. Try again later.',
        email: 'Reminder email has been sent successfully.',
        deadlineButton: 'Verification Reminder',
    },
    ActivationDetailsProduct: {
        picture: 'Product Picture',
        name: 'Product Name',
        ean: 'EAN',
        size: 'Product Size',
        capacity: 'Capacity in g/ml',
        value: 'Market Price',
        tax: 'Product Tax (11,1%)',
    },
    ActivationHistoryTable: {
        from: 'Start date',
        to: 'End date',
        name: 'Activation name',
        status: 'Status',
        owner: 'Brand owner',
        type: 'Activation type',
        withSeeding: 'Seeding',
        withoutSeeding: 'No seeding',
        empty: "Product's activation history is empty.",
        error: "Failed to download product's activation history.",
    },
    ActivationsList: {
        title: 'Dashboard',
        innerTitle: 'Activation List',
        date: 'Creation date',
        name: 'Activation Name',
        step: 'Step',
        statusLabel: 'Status',
        live: 'LIVE',
        po: 'PO',
        details: 'Details',
        empty: 'Activation list is empty.',
        id: 'id',
        search: 'Name',
        status: {
            draft: 'Draft',
            waiting: 'Waiting for approval',
            approvedWaiting: 'Approved waiting for copy',
            approvalCopy: 'Waiting for copy approval',
            approved: 'Approved with all documents',
            request: 'Request for improvement',
            rejected: 'Rejected',
            waitingForSeedingVerification: 'Waiting for seeding verification',
            seedingVerified: 'Seeding verified',
        },
        downloadError: 'Failed to download the file',
        filter: 'Filter by:',
        verification: 'Verification',
        task1: 'Task 1',
        task2: 'Task 2',
    },
    ActivationPanelMobile: {
        info: 'Sorry, this website only works on',
        infoContinued: 'desktop',
    },
    ActivationPreview: {
        title: 'Dashboard',
        innerTitle: 'Activation details',
        hint: 'This is your activation status. If you have any questions to your status please contact LOREALISTAR project leader.',
        edit: 'Edit',
        delete: 'Delete',
        deleteError: 'Failed to delete the activation',
        createdAt: 'Creation Date',
        step: 'Step',
        owner: 'Activation owner (e-mail)',
        type: {
            label: 'Activation Type',
            seeding: 'Konkurs z seedingiem',
            noSeeding: 'Konkurs bez seedingu',
        },
        task: 'Task Scenario',
        focus: 'Unique concept',
        division: 'Disivsion',
        brand: 'Brand',
        club: 'User Group/Club',
        packagesCount: 'Number of packages',
        productsCount: 'Number of products in 1 package',
        usersCount: 'Number of Users that can be Rewarded',
        taxableReward: 'Taxable Reward',
        tasks: 'Tasks',
        taskType: 'Task Type',
        taskDuration: 'Task duration',
        taskStart: 'Start Date',
        taskEnd: 'End Date',
        rewards: 'Rewards',
        rewardsCount: 'Number of Rewards',
        rewardPicture: 'Reward Picture',
        rewardName: 'Reward Name',
        rewardValue: 'Reward Market Value in PLN',
        rewardTax: 'Vat',
        rewardTaxValue: 'Reward Tax (11,1%)',
        products: 'Products',
        productPicture: 'Product Picture',
        productName: 'Product Name',
        productSize: 'Product Size',
        productCapacity: 'Capacity in g/ml',
        productValue: 'Market Price',
        productTax: 'Product Tax (11,1%)',
        ean: 'EAN',
        packageType: 'Packaging Type',
        productsIncluded: 'Products included in 1 package',
        packageProductCost: 'Cost per Package (logistics cost net)',
        totalProductCost: 'Total Cost (logistics cost net)',
        yes: 'Yes',
        no: 'No',
        start: 'Start Date',
        end: 'End Date',
        displayName: 'Display name',
        name: 'Contest name',
        template: 'Template',
        comment: 'Your Additional Comment',
        status: {
            draft: 'Draft',
            waiting: 'Waiting for approval',
            approvedWaiting: 'Approved waiting for copy',
            approvalCopy: 'Waiting for copy approval',
            approved: 'Approved with all documents',
            request: 'Request for improvement',
            rejected: 'Rejected',
        },
        button: {
            download: 'Download PDF',
            preview: 'Preview copy',
            complete: 'Complete task copy',
        },
        notCompleted: 'Not Completed',
        completed: 'Completed',
        deleted: 'Activation has been successfully deleted.',
        downloadError: 'Failed to download this file',
        verify: 'Verify seeding',
    },
    ActivationSeedingVerification: {
        title: 'Seeding verification',
        products: 'Products',
        packagesCount: 'Number of packages',
        productsCount: 'Number of products in 1 package',
        packageType: 'Packaging Type',
        productsIncluded: 'Products included in 1 package',
        packageProductCost: 'Cost per Package (logistics cost net)',
        totalProductCost: 'Total Cost (logistics cost net)',
        back: 'Back',
        save: 'Save',
        verifiedPackagesCount: {
            label: 'Number of delivered packages',
            placeholder: 'Fill',
            error: {
                min: 'The number of packages delivered cannot be less than zero',
                max: 'The number of packages delivered cannot exceed the number of packages in the activation',
            },
        },
    },
    ActivationSummary: {
        title: 'Activation Summary',
        seeding: 'Seeding',
        rewards: 'Other taxable rewards',
        diamonds: 'Rewards in diamonds',
        brandBudget: 'Brand budget',
        cdmoBudget: 'CDMO Budget',
        prices: {
            allActivationRewardsInDiamonds: 'All Activation Rewards in Diamonds',
            allActivationRewardsInPlnGross: 'All Activation Rewards in PLN gross',
            allActivationRewardsInPlnNet: 'All Activation Rewards in PLN net',
            aveMainReward: 'AVE. Value of SoMe Publication Reward in LOREALISTAR (Main Reward)',
            aveSecondaryReward:
                'AVE. Value of SoMe Publication Reward in LOREALISTAR (Secondary Reward)',
            logisticsCostForAllPackagesGross: 'Logistics Cost for All Packages gross',
            logisticsCostForAllPackagesNet: 'Logistics Cost for All Packages net',
            numberOfMainRewards: 'Number of Main Reward',
            numberOfSecondaryRewards: 'Number of Secondary Reward',
            productMarketValueInOnePackage: 'Product Market Value in 1 Package',
            productsTaxCostForAllPackages: 'Products Tax Cost for All Packages',
            questionnaireRewardInTotalNet: 'Questionnaire Reward in Total net',
            quizRewardInTotalNet: 'Quiz Reward in Total net',
            remainingBudgetNet: 'Remaining budget net',
            remainingBudgetGross: 'Remaining budget gross',
            rewardMarketValueGross: 'Reward Market Value gross',
            rewardMarketValueNet: 'Reward Market Value net',
            rewardTax: 'Reward Tax (11,1%)',
            suggestedSeedingCoefficient: '(Suggested LOREALISTAR seeding coefficient)',
            sumGross: 'Sum gross',
            sumNet: 'Sum net',
            taskWithPublicationMainRewardInTotalNet:
                'Task With Publication Main Reward in Total net',
            taskWithPublicationMainRewardNet: 'Task With Publication Main Reward net',
            taskWithPublicationSecondaryRewardInTotalNet:
                'Task With Publication Secondary Reward in Total net',
            taskWithPublicationSecondaryRewardNet: 'Task With Publication Secondary Reward net',
            totalProductMarketValueInAllPackages: 'Total Product Market Value in all Packages',
            totalProductTaxInOnePackage: 'Total Product Tax in 1 Package',
            totalRewardCostGross: 'Other Taxable Rewards gross',
            totalRewardCostNet: 'Other Taxable Rewards net',
            totalRewardMarketValueGross: 'Total Reward Market Value gross',
            totalRewardMarketValueNet: 'Total Reward Market Value net',
            totalSeedingCostForActivationGross: 'Total Seeding Cost for activation gross',
            totalSeedingCostForActivationNet: 'Total Seeding Cost for activation net',
            totalRewardTax: 'Total Reward Tax (11,1%)',
            logisticsInfo: '(Logistics Cost for All Packages + Products Tax Cost for All Packages)',
            totalInfo: '(Total Seeding Cost for activation + Total Rewards Cost in PLN)',
            coefficient: '(Suggested LOREALISTAR seeding coefficient)',
            coefficientHint: (values: string) =>
                `<span>Suggested LOREALISTAR seeding coefficient</span> <br> ${values}`,
            numberOfMainRewardsHint: (value: string) => `${value}% of all packages `,
            taskWithPublicationMainRewardNetHint: (value: string) =>
                `Calculated based on below formula: AVE. Value of SoMe Publication Reward in LOREALISTAR (Main Reward) - (Product Market Value in 1 Package * LOREALISTAR seeding coefficient here: ${value} - (product total*x%)`,
            taskWithPublicationSecondaryRewardNetHint: (value: string) =>
                `Calculated based on below formula: AVE. Value of SoMe Publication Reward in LOREALISTAR (Secondary Reward) - (Product Market Value in 1 Package * LOREALISTAR seeding coefficient here: ${value} - (product total*x%)`,
            numberOfSecondaryRewardsHint: (value: string) => `${value}% of all packages `,
            questionnaireRewardInTotalNetHint: (value: string) => `number of packages x ${value}`,
            quizRewardInTotalNetHint: (value: string) => `number of packages x ${value}`,
        },
    },
    ActivationTask: {
        title: 'Task',
        back: 'Back',
        save: 'Save',
        next: 'Go to next step',
        backToDetails: 'Back to activation details',
        send: 'Accept and send',
        type: 'Task Type',
        displayName: 'Activation Display name',
        price: 'Price',
        start: 'Start Date',
        end: 'End Date',
        stage: 'Etap',
        from: 'z',
        content: 'Task content',
        endMessage: 'Contest End Message',
        sharepoint: {
            label: 'SharePoint Link to any additional materials (foto, wideo etc.)',
            placeholder: 'Fill',
            required: 'This field is required',
        },
        push: {
            label: 'Push',
            placeholder: 'Select',
            required: 'This field is required',
            yes: 'Yes',
            no: 'No',
        },
        pushDate: {
            label: 'Date',
            placeholder: 'Fill',
            required: 'This field is required',
            range: (start: string, end: string) => `Push date must be between ${start} and ${end}`,
        },
        pushTime: {
            label: 'Time',
            placeholder: 'Fill',
            required: 'This field is required',
        },
        pushContent: {
            label: 'Message Content',
            placeholder:
                'Fill (push content, max 150 characters, possibility to use emoji, no formatting possible ex. bold, cursive)',
            required: 'This field is required',
            max: 'This field cannot contain more than 150 characters',
        },
        copy: {
            required: 'Complete the missing field',
        },
        success: 'Activation template has been successfully saved',
        successVerification: 'Activation template has been sent for verification',
        error: 'Please correct errors in marked fields',
    },
    ActivationTemplate: {
        title: 'Template',
    },
    ActivationTemplateSteps: {
        step: 'Step',
    },
    ActivationTemplateStepOneForm: {
        goal: {
            label: 'Activation Goal',
            placeholder: 'Fill',
            required: 'This field is required',
        },
        displayName: {
            label: 'Activation Display name',
            placeholder: 'Fill',
            required: 'This field is required',
        },
        brand: 'Brand',
        start: 'Start Date',
        end: 'End Date',
        duration: 'Duration',
        days: 'days',
        budget: 'All Activation Rewards in Diamonds',
        seeding: 'Total Seeding Costs with Tax',
        seedingNet: 'Total Seeding Cots net',
        seedingTax: 'Seeding Tax Cost',
        noSeeding: 'Total Taxable Rewards Costs with Tax',
        noSeedingNet: 'Total Taxable Rewards Costs net',
        noSeedingTax: 'Taxable Rewards Tax Cost',
        save: 'Save',
        backToDetails: 'Back to activation details',
        next: 'Go to next step',
        success: 'Activation template has been successfully saved',
        error: 'Please correct errors in marked fields',
    },
    Api: {
        networkError: 'Wystąpił problem z siecią',
        unknownError: 'Wystąpił błąd. Spróbuj ponownie później',
    },
    AwardPrize: {
        title: 'Choose The Winners',
        back: 'Back to Activation details',
        awarded: 'The application has been successfully awarded',
        awardedError: 'The application could not be awarded. Try again later.',
        revoked: 'The award has been successfully revoked',
        revokedError: 'The application award could not be revoked. Try again later.',
        markPretender: 'The application has been successfully marked as a pretender',
        markError: 'The application could not be marked as a pretender. Try again later.',
        unmarkPretender: 'The application has been successfully unmarked as a pretender',
        unmarkError: 'The application could not be unmarked as a pretender. Try again later.',
        finish: 'Finish verification',
        verificationFinishSuccess: 'Verification has been successfully finished',
        verificationFinishError: 'Something went wrong. Try again later.',
        count: 'Number of applications',
        nullCount: 'Number of null applications',
        tiktokCount: 'Number of TikTok applications',
        instagramCount: 'Number of Instagram applications',
        deadline: 'Deadline',
        error: 'Failed to download list of applications. Please try again later.',
        empty: 'List of applications is empty.',
        awardAll: 'Award all',
        awardedMany: (count: number) => `Successfully awarded ${count} applications`,
        awardedManyError: `An error occurred while attempting to award all applications.`,
    },
    AwardPrizes: {
        first: '1st prize',
        second: '2nd prize',
    },
    BrandFieldArray: {
        add: 'Add brand',
        label: 'Brand and brand budget',
        delete: 'Delete',
        brand: {
            label: 'Brand',
            placeholder: 'Select',
            error: 'Please, choose a brand of your activation',
        },
        budgetPercent: {
            label: 'Budget split in',
            placeholder: 'Fill',
        },
        owner: {
            label: 'Activation Owner (e-mail)',
            placeholder: 'Fill',
            error: 'Please, type in an correct email',
        },
    },
    ChangeBudget: {
        title: 'Change Budget',
        back: 'Back to cost summary',
        save: 'Save',
        history: 'Changes history',
        empty: 'No changes for selected budget',
        budget: {
            current: 'Current budget',
            new: 'New budget',
            placeholder: 'Fill',
            error: {
                required: 'Enter new budget',
                min: (min: number | string) => `The new budget cannot be less than ${min}`,
            },
        },
        error: 'An error occurred and the data for the selected criteria could not be loaded.',
        table: {
            date: 'Date',
            user: 'User',
            previous: 'Previous budget',
            next: 'New budget',
        },
    },
    CopyField: {
        fill: 'Fill',
        ok: 'Ok',
        edit: 'Edit',
        placeholder: 'Please enter your copy',
    },
    CostSummary: {
        title: 'Cost Summary',
        search: 'Search activation',
        titleCdmo: 'CDMO budget split by conso %',
        titleBrand: 'Brand budget',
        titleDivision: 'Division budget',
        change: 'Change budget',
        budget: 'BUDGET',
        budgetEstimated: 'WHAT IS LEFT - estimated',
        budgetReal: 'WHAT IS LEFT - real',
        packagesEstimated: 'PACKAGES THAT I CAN SEND - estimated',
        packagesEstimatedHint:
            'Estimated number of packages that you can send with the budget you have left.',
        packagesReal: 'PACKAGES THAT I CAN SEND - real',
        packagesRealHint: 'Real number of packages that you can send with the budget',
        verify: 'verify seeding',
        empty: 'No activation for selected search criteria',
        error: 'An error occurred and the data for the selected criteria could not be loaded.',
        table: {
            activationName: 'Activation name',
            brandName: 'Brand name',
            cdmo: {
                estimatedCost: 'Estimated all activation rewards in PLN',
                realCost: 'Real all activation rewards in PLN',
                estimatedTax: 'Estimated all activations rewards tax in PLN',
                realTax: 'Real all activations rewards tax in PLN',
                title: 'CDMO budget split by conso %',
            },
            brand: {
                estimatedCost: 'Estimated logistics cost for all packages in PLN',
                realCost: 'Real logistics cost for all packages in PLN',
                estimatedTax: 'Estimated products tax cost for all packages in PLN',
                realTax: 'Real products tax cost for all packages in PLN',
                title: 'Brand budget',
            },
            poNumber: 'PO number for logistics cost',
            budgetPercent: 'Budget split in %',
        },
        downloadPdf: 'Download Summary PDF',
        downloadError: 'Failed to download PDF file. Try again later.',
        divisions: 'Divisions',
        brands: 'Brands',
    },
    Calendar: {
        title: 'Activation Calendar',
    },
    Dashboard: {
        title: 'Dashboard',
        tasks: 'Activation summary',
        seedings: 'Seeding summary',
        categories: 'Activation category',
        concepts: 'Activation concept',
        legend: {
            question: 'Which activations count towards each category?',
            placeholders: 'Placeholders: All activations that have the status "placeholder"',
            verified: 'Verified: All activations that have the status "seeding-verified"',
            progress:
                'In progress: All activations that are currently in progress and not verified',
            planned: 'Planned: All activations with a future start date and not verified',
            completed:
                'Completed: All activations with an expiration date in the past and not verified',
            rest: {
                info: 'All activations with one of these statuses:',
                'waiting-for-approval': 'Waiting for approval',
                'approved-waiting-for-copy': 'Approved, waiting for copy',
                'approval-copy': 'Waiting for copy approval',
                'approved-with-all-documents': 'Approved with all documents',
                'request-for-improvement': 'Request for improvement',
                'seeding-verified': 'Seeding verified',
                'waiting-for-seeding-verification': 'Waiting for seeding verification',
            },
        },
    },
    DraftsList: {
        title: 'Drafts',
        error: 'Failed to download drafts. Try again later.',
        empty: 'The drafts list is empty',
    },
    Filter: {
        button: {
            less: 'Mniej',
            more: 'Więcej',
        },
    },
    Filters: {
        filters: 'Filtry',
        showAll: 'Pokaż wszystkie produkty',
        closeFilters: 'Schowaj filtry',
    },
    FilterTag: {
        clear: 'Wyczyść filtr',
    },
    Footer: {
        copyright: 'Wszystkie prawa zastrzeżone ©',
    },
    FooterNavList: {
        openNavigation: 'Rozwiń menu:',
    },
    Header: {
        buttons: {
            search: 'Szukaj',
            showNavigation: 'Otwórz menu',
            hideNavigation: 'Zamknij menu',
        },
    },
    ActivationDeliveryModal: {
        title: 'What is the reason for the activation hold?',
        question: 'Are you sure you want to hold this activation?',
        yes: 'Yes',
        no: 'No',
        reason: {
            label: 'Reason',
            required: 'This field is required',
        },
        holdButton: 'Hold activation',
        readyButton: 'Ready to go live',
        onetribe: 'One2Tribe',
        owner: 'Activation Owner',
        readyToGoLiveSuccess: 'Activation is now ready to go live!',
        readyToGoLiveError: "Failed to mark activation as 'Ready to go live!' Try again later.",
        holdSuccess: 'Activation has been successfully held',
        holdError: 'Failed to hold the activation. Try again later.',
    },
    ActivationDeliveryModalProduct: {
        image: 'Product Picture',
        name: 'Product Name',
        ean: 'EAN',
        capacity: 'Capacity in g/ml',
        value: 'Market Price',
        size: 'Product Size',
        tax: 'Product Tax',
        quantities: 'Quantities',
        total: 'Total quantity',
        available: 'Available quantity',
        reserved: 'Reserved quantity',
        reservedInProgress: 'Reserved in progress',
        planned: 'Products planned',
        live: 'Activation is live',
        completed: 'Activation is complete',
        enough: 'Enough',
        notEnough: 'Not Enough',
        enoughForThisSeeding: 'Enough for this seeding',
    },
    HtmlPlaceholderField: {
        fill: 'Fill',
        ok: 'Ok',
        edit: 'Edit',
        placeholder: 'Please enter your copy',
    },
    ImportHistoryTable: {
        title: 'Import History',
        date: 'Date',
        name: 'Import name',
        status: 'status',
    },
    Influencer: {
        title: 'Influencer',
        list: 'All influencers',
        edit: 'Edit influencer data',
        editCancel: 'Back to details',
        error: 'Failed to download influencer data. Try again later.',
    },
    InfluencerDeleteModal: {
        title: 'Delete influencer',
        description: (name: string) =>
            `Are you sure you want to permanently delete ${name}? This action cannot be undone.`,
        cancel: 'Cancel',
        confirm: 'Delete',
        success: 'The influencer has been deleted',
        error: 'Failed to delete the influencer. Try again later.',
    },
    InfluencerKpiCards: {
        titles: {
            active: 'Active Influencers',
            registered: 'Registered Influencers',
            pending: 'Pending Influencers',
            new: 'New Influencers',
        },
        values: {
            total: 'Total',
            standard: 'Standard',
            pro: 'Pro',
        },
    },
    InfluencerQuickActions: {
        title: 'Quick Actions',
        accept: 'Accept Influencer',
        reject: 'Reject application',
        restore: 'Restore to new',
        edit: 'Edit data',
        copy: 'Copy Email',
        copySuccess: 'Copied to clipboard',
        copyError: 'Failed to copy to clipboard',
        report: 'Report influencer',
        delete: 'Delete',
    },
    InfluencerAdd: {
        mainTitle: 'Influencers',
        list: 'Back to influencers list',
        title: 'Add new influencer',
    },
    InfluencerForm: {
        firstName: {
            label: 'First name',
            required: 'First name is required',
        },
        lastName: {
            label: 'Last name',
            required: 'Last name is required',
        },
        email: {
            label: 'Email',
            required: 'Email is required',
            email: 'Enter a valid email address',
        },
        instagramHandle: {
            label: 'Instagram handle',
            format: 'Enter a valid handle, e.g. @handle',
        },
        tiktokHandle: {
            label: 'TikTok handle',
            format: 'Enter a valid handle, e.g. @handle',
        },
        youtubeHandle: {
            label: 'YouTube handle',
            format: 'Enter a valid handle, e.g. @handle',
        },
        accountType: {
            label: 'Account type',
            required: 'Account type is required',
            standard: 'Standard',
            pro: 'PRO',
        },
        clubs: {
            label: 'Brand clubs',
        },
        segmentation: {
            label: 'Segmentation',
        },
        create: 'Add influencer',
        save: 'Save changes',
        successAdd: 'The influencer has been added',
        successEdit: 'The influencer has been updated',
        errorAdd: 'Failed to add the influencer. Try again later.',
        errorEdit: 'Failed to update the influencer. Try again later.',
    },
    InfluencerListing: {
        title: 'Influencers',
        tabs: {
            list: 'Influencer list',
            applications: 'Applications',
            import: 'Import/Export',
        },
    },
    ActiveFilters: {
        clearAll: 'Clear all filters',
    },
    TableColumnPicker: {
        trigger: 'Columns',
        reset: 'Restore defaults',
    },
    InfluencerImportHistory: {
        title: 'Import history',
        date: 'Date',
        file: 'File',
        author: 'Started by',
        accountType: 'Account type',
        accountTypes: {
            standard: 'Standard',
            pro: 'PRO',
        },
        status: 'Status',
        result: 'Created / updated / skipped',
        empty: 'No imports yet',
        error: 'Failed to download the import history. Try again later.',
        counts: (created: number, updated: number, skipped: number) =>
            `${created} / ${updated} / ${skipped}`,
        progress: (percent: number) => `${percent}%`,
        previous: 'Previous',
        next: 'Next',
        pageOf: (page: number, pageCount: number) => `Page ${page} of ${pageCount}`,
    },
    InfluencersImport: {
        title: 'Influencers import/export',
        historyTitle: 'Influencers imports',
        importTitle: 'Import',
        importSub:
            'Upload the weekly status report (CSV, XLS or XLSX). Influencers are matched by email. The file is processed in the background, so you can leave this page.',
        expectedColumns: 'Expected columns',
        import: 'Import',
        file: {
            required: 'File is required',
        },
        accountType: {
            label: 'File type',
            placeholder: 'Select the report type',
            hint: 'Every influencer from the file gets this account type.',
            standard: 'Account status (Standard)',
            pro: 'Account status PRO',
            required: 'Select the report type',
        },
        queued: 'The file has been queued. Progress is shown below.',
        progress: (percent: number, processed: number, total: number) =>
            total > 0
                ? `${percent}% (${processed} of ${total} rows)`
                : `${percent}%, counting rows`,
        pollingTimedOut:
            'The import is taking longer than expected. Check the import history below for the final result.',
        downloadErrors: 'Download error report (CSV)',
        errorsDownloadError: 'Failed to download the error report. Try again later.',
        success: 'Influencers imported successfully',
        error: 'Failed to import influencers list. Try again later.',
        report: {
            created: 'Created',
            updated: 'Updated',
            skipped: 'Skipped',
            errorsCount: 'Errors',
            unmatchedGroups: 'Groups not matched to any dictionary',
            errors: 'Rows that could not be imported',
        },
        exportTitle: 'Export',
        exportSub: 'Download the full influencers list as an XLSX file.',
        export: 'Export influencers',
        exportO2tTitle: 'Export for One2Tribe',
        exportO2tSub:
            'Download accepted applications in the One2Tribe upload template (users, instructions and groups sheets).',
        exportO2t: 'Export accepted applications',
        exportError: 'Failed to export influencers list. Try again later.',
    },
    SlidePanelLayout: {
        close: 'Close',
    },
    InfluencerActivitySummary: {
        title: 'Activity Summary',
        seedings: 'Seedings received',
        publications: 'Publications',
        missionsApplied: 'Missions applied',
        missionsWon: 'Missions won',
    },
    InfluencerActivity: {
        title: 'Activity log',
        empty: 'No activity yet.',
    },
    InfluencerAttributes: {
        title: 'Segmentation & Brand Clubs',
        save: 'Save changes',
        cancel: 'Discard',
        saved: 'Attributes have been updated',
        error: 'Failed to update attributes. Try again later.',
        remove: 'Remove',
        segmentation: {
            title: 'Segmentation',
            placeholder: 'Add segmentation…',
            empty: 'No segmentation assigned yet.',
        },
        clubs: {
            title: 'Brand clubs',
            placeholder: 'Add brand club…',
            empty: 'Not assigned to any brand club yet.',
        },
    },
    InfluencerBlacklist: {
        title: 'Blacklist Status',
        placeholder: 'Add brand to blacklist…',
        selectAll: 'Select all brands',
        divisions: 'Whole division:',
        empty: 'Not blacklisted for any brand.',
        remove: 'Remove',
        save: 'Save changes',
        cancel: 'Discard',
        saved: 'The blacklist has been updated',
        error: 'Failed to update the blacklist. Try again later.',
    },
    InfluencerAwardMenu: {
        more: 'More actions',
        addClub: 'Add to brand club',
        report: 'Report influencer',
    },
    InfluencerAddClub: {
        title: 'Add to brand club',
        description: (name: string) =>
            `Add ${name} to a club selected in this activation. The next One2Tribe status import overwrites the clubs, so the change stays only if One2Tribe adds the club on their side as well.`,
        clubLabel: 'Brand club',
        clubRequired: 'Select a club',
        confirm: 'Add to club',
        cancel: 'Cancel',
        success: 'The participant has been added to the club',
        error: 'Failed to add the participant to the club. Try again later.',
    },
    InfluencerReportModal: {
        title: 'Report influencer',
        description: (name: string) =>
            `Describe what happened with ${name}, e.g. breaking the rules or a poor publication. The report stays on the profile.`,
        messageLabel: 'Report details',
        messageRequired: 'Report details are required',
        confirm: 'Send report',
        cancel: 'Cancel',
        success: 'The report has been saved',
        error: 'Failed to save the report. Try again later.',
    },
    InfluencerDecisions: {
        title: 'Previous applications',
        attempt: (attempt: number) => `Attempt ${attempt}`,
        empty: 'No decisions on previous applications.',
    },
    InfluencerReports: {
        title: 'Reports',
        empty: 'No reports yet.',
        deletedAuthor: 'Deleted user',
    },
    InfluencerActivations: {
        title: 'Activation history',
        empty: 'No activation history yet.',
        unnamedTask: 'Task',
        taskCount: (count: number) => `${count} task(s)`,
        post: 'Open post',
        seedings: (count: number) => `${count} product(s)`,
        changeOutcome: 'Change outcome',
        manualOutcome: 'set manually',
    },
    InfluencerOutcomeModal: {
        title: 'Change outcome',
        description: (taskName: string) =>
            `${taskName}. Prizes and prize candidates are set on the activation and always take precedence.`,
        outcome: {
            label: 'Outcome',
            automatic: 'Automatic (calculated from the task data)',
        },
        outcomes: {
            'no-response': 'No response',
            'brief-only': 'Finished at brief stage',
            'next-stage': 'Advanced to next stage',
            'no-address': 'No address provided',
            'product-not-sent': 'Product not sent',
            'product-sent': 'Product sent',
            'task-not-done': 'Task not completed',
            'task-done': 'Task completed',
        },
        success: 'The outcome has been saved',
        error: 'Failed to save the outcome. Try again later.',
        cancel: 'Cancel',
        confirm: 'Save',
    },
    InfluencerBulkActions: {
        selected: (count: number) => `${count} selected`,
        selectedMatching: (count: number) => `${count} selected, all matching the filters`,
        selectedMatchingExcept: (count: number, excluded: number) =>
            `${count} selected, all matching the filters except ${excluded}`,
        selectAllMatching: (count: number) => `Select all ${count} matching the filters`,
        copyEmails: 'Copy emails',
        accept: 'Accept selected',
        reject: 'Reject selected',
        segmentation: 'Assign segmentation',
        clear: 'Clear selection',
        acceptModal: {
            title: 'Accept selected',
            description: (count: number) =>
                `${count} application(s) will be accepted. The comment is visible to One2Tribe on each of them.`,
            commentLabel: 'Comment for One2Tribe (optional)',
            confirm: 'Accept',
            cancel: 'Cancel',
        },
        rejectModal: {
            title: 'Reject selected',
            description: (count: number) =>
                `${count} application(s) will be rejected. The reason is saved in the activity log of each of them.`,
            reasonLabel: 'Reason (optional)',
            confirm: 'Reject',
            cancel: 'Cancel',
        },
        confirm: {
            title: 'Confirm the bulk action',
            message: (action: string, count: number) =>
                `"${action}" will be applied to all ${count} influencer(s) matching the current filters, not only the ones visible on this page.`,
            confirm: 'Yes, continue',
            cancel: 'Cancel',
        },
        copied: (count: number) => `Copied ${count} email address(es)`,
        copyError: 'Failed to copy to clipboard',
        error: 'The bulk action could not be completed. Try again later.',
        finished: (count: number) => `Done for ${count} influencer(s)`,
        finishedWithErrors: (done: number, failed: number) =>
            `Done for ${done} influencer(s), ${failed} failed`,
    },
    InfluencerBulkSegmentationModal: {
        title: 'Assign segmentation',
        description: (count: number) => `The change will be applied to ${count} influencer(s).`,
        segmentation: {
            label: 'Segmentation',
            placeholder: 'Choose values…',
        },
        modes: {
            label: 'Mode',
            add: 'Add to current values',
            replace: 'Replace current values',
        },
        emptySelection: 'Choose at least one segmentation value',
        cancel: 'Cancel',
        confirm: 'Apply',
        error: 'Failed to assign segmentation. Try again later.',
    },
    InfluencerCooperation: {
        headline: (count: number) => `${count} activation(s)`,
        completionRate: 'tasks completed',
    },
    InfluencerBadges: {
        statuses: {
            new: 'New',
            accepted: 'Accepted',
            rejected: 'Rejected',
        },
        accountStatuses: {
            ACTIVATED: 'Activated',
            REGISTERED: 'Registered',
            BLOCKED: 'Blocked',
        },
        importStatuses: {
            queued: 'Queued',
            running: 'In progress',
            done: 'Finished',
            failed: 'Failed',
        },
    },
    InfluencerSlidePanelModal: {
        title: 'Influencer',
        error: 'Failed to download influencer data. Try again later.',
        previous: 'Previous influencer',
        next: 'Next influencer',
        openFullPage: 'Open full page',
        edit: 'Edit influencer data',
    },
    InfluencerExportActions: {
        copyEmails: 'Copy emails',
        copyEmailsWithCount: (count: number) => `Copy emails (${count})`,
        copySuccess: (count: number) => `Copied ${count} email address(es)`,
        copyEmpty: 'No influencers match the current filters',
        copyError: 'Failed to copy the email list. Try again later.',
        export: 'Export XLSX',
        exportError: 'Failed to export the influencers list. Try again later.',
    },
    InfluencerFacts: {
        id: 'ID',
        playerId: 'Player ID',
        accountStatus: 'Account status',
        registered: 'Registered',
        lastLogin: 'Last login',
        importNote: 'Unmatched groups from import',
    },
    InfluencersList: {
        titles: {
            list: 'Influencer list',
            applications: 'Applications',
        },
        add: 'Add influencer',
        error: 'Failed to download influencers. Try again later.',
        empties: {
            list: 'The influencers list is empty',
            applications: 'There are no applications',
        },
        search: 'Search by name, handle, email or player ID',
        filter: 'All',
        sortPlaceholder: 'Default order',
        moreFilters: 'More filters',
        fewerFilters: 'Fewer filters',
        resultCount: (count: number) => `${count} influencer(s) match the filters`,
    },
    InfluencerFiltersModal: {
        title: 'Filters',
        clearAll: 'Clear all',
        apply: 'Apply filters',
        placeholder: 'All',
        groups: {
            status: 'Status & Account',
            brands: 'Brands & Segmentation',
            activity: 'Logins & Activity',
            performance: 'Activations & Performance',
            other: 'Other',
        },
    },
    InfluencerListToolbar: {
        search: 'Search by name, handle, email or player ID',
        filters: 'Filters',
        sort: 'Sort',
        defaultSort: 'Default order',
        activeFilters: (count: number) => `Active filters (${count} results):`,
        resultCount: (count: number) => `${count} influencer(s)`,
    },
    InfluencerStatusModal: {
        cancel: 'Cancel',
        accept: {
            title: 'Accept influencer',
            description: (name: string) => `Are you sure you want to accept ${name}?`,
            commentLabel: 'Comment for One2Tribe (optional)',
            confirm: 'Accept',
            success: 'The influencer has been accepted',
            error: 'Failed to accept the influencer. Try again later.',
        },
        reject: {
            title: 'Reject influencer',
            description: (name: string) => `Are you sure you want to reject ${name}?`,
            reasonLabel: 'Reason (optional)',
            confirm: 'Reject',
            success: 'The influencer has been rejected',
            error: 'Failed to reject the influencer. Try again later.',
        },
        restore: {
            title: 'Restore application',
            description: (name: string) =>
                `${name} will go back to the "New" status and wait for another review.`,
            confirm: 'Restore',
            success: 'The application has been restored',
            error: 'Failed to restore the application. Try again later.',
        },
    },
    InfluencerTable: {
        id: 'Id',
        name: 'Full name',
        email: 'Email',
        instagram: 'Instagram',
        tiktok: 'TikTok',
        youtube: 'YouTube',
        playerId: 'Player ID',
        clubs: 'Brand clubs',
        segmentation: 'Segmentation',
        accountType: 'Account type',
        accountStatus: 'Account status',
        lastLogin: 'Last login',
        registered: 'Registered',
        status: 'Status',
        actions: 'Actions',
        accept: 'Accept',
        reject: 'Reject',
        restore: 'Restore',
        edit: 'Edit',
        blacklist: 'Blacklist',
        attempt: (attempt: number) => `Attempt ${attempt}`,
        standard: 'Standard',
        select: 'Select influencer',
        selectAll: 'Select all on this page',
        activations: 'Activations',
        completedTasks: 'Completed tasks',
        seedings: 'Seedings',
        prizes: 'Prizes',
        effectiveness: 'Effectiveness',
        lastActivity: 'Last activity',
    },
    Input: {
        showPassword: 'Pokaż hasło',
    },
    InputFile: {
        errorRead: (name: string) => `Failed to upload the file ${name}.`,
        maxSize: (maxSize: number, name: string) =>
            `The ${name} file is too large, the maximum file size is ${maxSize}MB.`,
        maxCount: (maxCount: number) => `The maximum number of files is ${maxCount}.`,
        upload: 'Click to add',
        typeNotAccepted: (mimeType: string) => `Illegal file extension: ${mimeType}.`,
    },
    InstagramRegisterForm: {
        firstName: {
            label: 'Imię*',
            placeholder: 'Wprowadź ',
            required: 'Proszę wprowadzić imię',
        },
        lastName: {
            label: 'Nazwisko*',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić nazwisko',
        },
        email: {
            label: 'Adres e-mail*',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić e-mail',
        },
        instagramName: {
            label: 'Nazwa konta na Instagramie*',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić nazwę konta',
            note: 'np.: @haniabeauty',
        },
        tiktokName: {
            label: 'Nazwa konta na TikToku',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić nazwę konta',
            note: 'np.: @haniabeauty',
        },
        youtubeName: {
            label: 'Nazwa konta na YouTube',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić nazwę konta',
            note: 'np.: @haniabeauty',
        },
        consent1: {
            label: (url: string) =>
                `Akceptuję warunki <a class="link" style="text-decoration: none" href='${url}' target="_blank"><span style="font-weight: bold">Regulaminu Weryfikacji</span></a> w tym postanowienia dotyczące ochrony danych osobowych.`,
            required: 'Ta zgoda jest wymagana',
        },
        consent2: {
            label: (url: string) =>
                `Wyrażam zgodę na weryfikację moich danych osobowych, w tym mojego konta i publikowanych przeze mnie treści w serwisie Instagram zgodnie z postanowieniami <a class="link" style="text-decoration: none" href='${url}' target="_blank"><span style="font-weight: bold">Regulaminu Weryfikacji</a> przez L’ORÉAL Polska Sp. z o.o. ul. Grzybowska 62, 00-844 Warszawa w celu możliwości przystąpienia do Platformy Konkursowej LOREALISTAR. Informujemy o przysługującym prawie do wycofania zgody w dowolnym momencie. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. Wycofanie zgody możliwe jest za pośrednictwem kontaktu na adres e-mail: <span style="text-decoration: underline">personal-da@loreal.com.</span>`,
            required: 'Ta zgoda jest wymagana',
        },
        followers: {
            label: 'Czy posiadasz minimum 1000 obserwujących na jednej z platform: Instagram, TikTok lub YouTube?*',
            required: 'Ta zgoda jest wymagana',
            options: {
                yes: 'Tak',
                no: 'Nie',
            },
        },
        ofAge: {
            label: 'Czy potwierdzasz, że ukończyłeś/aś 18 lat?*',
            required: 'Ta zgoda jest wymagana',
            options: {
                yes: 'Tak',
                no: 'Nie',
            },
        },
        shippingAddress: {
            label: 'Czy posiadasz stały adres do wysyłki paczek w Polsce?*',
            required: 'Ta zgoda jest wymagana',
            options: {
                yes: 'Tak',
                no: 'Nie',
            },
        },
        knowledge: {
            label: 'W jaki sposób otrzymałaś/eś link do formularza rejestracyjnego Lorealistar?*',
            required: 'Ta informacja jest wymagana',
            options: {
                label: 'Otrzymałam/em zaproszenie do Lorealistar w wiadomości na IG/e-mail od agencji Enyo.',
                label2: 'Dowiedziałam/em się o Lorealistar z innego źródła (np. przez znajomych, media społecznościowe etc.) i zgłosiłam/em chęć dołączenia.',
            },
        },
        description: {
            label: 'Dlaczego powinniśmy wybrać Ciebie do społeczności Lorealistar?*',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić odpowiedź',
        },
        submit: 'WYSYŁAM ZGŁOSZENIE I POBIERAM REGULAMIN',
    },
    LoginForm: {
        email: {
            label: 'E-mail address',
            placeholder: 'haniakowalska@gmail.com',
            error: {
                required: 'E-mail is required',
                email: 'Please enter a valid e-mail address.',
            },
        },
        password: {
            label: 'Password',
            placeholder: '***********',
            error: {
                required: 'Password is required',
                min: 'The password should be at least 8 characters long',
                max: 'The password cannot be longer than 32 characters',
            },
        },
        submit: {
            label: 'Login',
        },
    },
    LoginFormWithLink: {
        question: 'Nie pamiętasz hasła?',
        link: 'Odzyskaj hasło',
    },
    Logo: {
        title: 'Strona główna',
    },
    LorealistarProRegisterForm: {
        firstName: {
            label: 'Imię*',
            placeholder: 'Wprowadź ',
            required: 'Proszę wprowadzić imię',
        },
        lastName: {
            label: 'Nazwisko*',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić nazwisko',
        },
        email: {
            label: 'Adres e-mail*',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić e-mail',
        },
        instagramName: {
            label: 'Nazwa konta na Instagramie*',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić nazwę konta',
            note: 'np.: @haniabeauty',
        },
        tiktokName: {
            label: 'Nazwa konta na TikToku',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić nazwę konta',
            note: 'np.: @haniabeauty',
        },
        youtubeName: {
            label: 'Nazwa konta na YouTube',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić nazwę konta',
            note: 'np.: @haniabeauty',
        },
        consent1: {
            label: (url: string) =>
                `Akceptuję warunki <a class="link" style="text-decoration: none" href='${url}' target="_blank"><span style="font-weight: bold">Regulaminu Weryfikacji</span></a> w tym postanowienia dotyczące ochrony danych osobowych.`,
            required: 'Ta zgoda jest wymagana',
        },
        consent2: {
            label: (url: string) =>
                `Wyrażam zgodę na weryfikację moich danych osobowych, w tym mojego konta i publikowanych przeze mnie treści w serwisie Instagram zgodnie z postanowieniami <a class="link" style="text-decoration: none" href='${url}' target="_blank"><span style="font-weight: bold">Regulaminu Weryfikacji</a> przez L’ORÉAL Polska Sp. z o.o. ul. Grzybowska 62, 00-844 Warszawa w celu możliwości przystąpienia do Platformy Konkursowej LOREALISTAR. Informujemy o przysługującym prawie do wycofania zgody w dowolnym momencie. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. Wycofanie zgody możliwe jest za pośrednictwem kontaktu na adres e-mail: <span style="text-decoration: underline">personal-da@loreal.com.</span>`,
            required: 'Ta zgoda jest wymagana',
        },
        consent3: {
            label: `Chcę dołączyć do programu <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.3em"/></span> i oświadczam, że:<ul style="margin: 8px 0 0; padding-left: 20px; list-style-type: disc"><li style="margin-bottom: 8px">zamierzam korzystać z Platformy Konkursowej jako konsument w rozumieniu art. 22<sup>1</sup> Kodeksu Cywilnego, a mój udział w Platformie Konkursowej ma charakter edukacyjny, hobbystyczny lub artystyczny i nie jest w żaden sposób związany z prowadzoną przeze mnie działalnością gospodarczą;</li><li style="margin-bottom: 8px">posiadam wiedzę lub doświadczenie zawodowe lub hobbystyczne w branży beauty (w zakresie minimum jednej z kategorii, tj. pielęgnacja i stylizacja włosów, zdrowie i pielęgnacja skóry, makijaż lub wizaż) i w ramach swojego profilu prowadzonego w mediach społecznościowych publikuję treści beauty o charakterze edukacyjnym, eksperckim lub zawodowym;</li><li>ukończyłem 18 lat, mam pełną zdolność do czynności prawnych, posiadam miejsce zamieszkania oraz stały adres do wysyłek paczek w Polsce, a także jestem polskim rezydentem podatkowym.</li></ul>`,
            required: 'Ta zgoda jest wymagana',
        },
        followers: {
            label: 'Czy posiadasz minimum 1000 obserwujących na jednej z platform: Instagram, TikTok lub YouTube?*',
            required: 'Ta zgoda jest wymagana',
            options: {
                yes: 'Tak',
                no: 'Nie',
            },
        },
        ofAge: {
            label: 'Czy potwierdzasz, że ukończyłeś/aś 18 lat?*',
            required: 'Ta zgoda jest wymagana',
            options: {
                yes: 'Tak',
                no: 'Nie',
            },
        },
        shippingAddress: {
            label: 'Czy posiadasz stały adres do wysyłki paczek w Polsce?*',
            required: 'Ta zgoda jest wymagana',
            options: {
                yes: 'Tak',
                no: 'Nie',
            },
        },
        experience: {
            label:
                'Posiadam wiedzę lub doświadczenie   \n' +
                'związane z branżą beauty lub aktualnie   \n' +
                'rozwijam się w tym kierunku:',
            options: {
                label: 'Pielęgnacja lub stylizacja włosów',
                label2: 'Zdrowie i pielęgnacja skóry',
                label3: 'Wizaż / makijaż',
            },
        },
        knowledge: {
            label: 'W jaki sposób otrzymałaś/eś link do formularza rejestracyjnego <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.25em"/></span>?*',
            required: 'Ta informacja jest wymagana',
            options: {
                label: 'Otrzymałam/em zaproszenie do <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.25em"/></span> w wiadomości na IG/e-mail od agencji Enyo.',
                label2: 'Dowiedziałam/em się o <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.25em"/></span> z innego źródła (np. przez znajomych, media społecznościowe etc.) i zgłosiłam/em chęć dołączenia.',
            },
        },
        description: {
            label: 'Dlaczego powinniśmy wybrać Ciebie do społeczności <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.25em"/></span>?*',
            placeholder: 'Wprowadź odpowiedź',
            required: 'Proszę wprowadzić odpowiedź',
        },
        submit: 'WYSYŁAM ZGŁOSZENIE I POBIERAM REGULAMIN',
    },
    ManufacturerList: {
        more: 'I wiele więcej',
    },
    ModalLayout: {
        cancel: 'nie',
        confirm: 'tak',
        close: 'Zamknij modal',
    },
    MobileNavigationList: {
        goTo: 'Przejdź do:',
    },
    HardApplication: {
        first: '1st',
        second: '2nd',
        seedings: 'Seedings:',
        clubs: 'User Group/Club:',
        segmentation: 'Segmentation:',
        link: 'Original link:',
        youtube: 'YouTube:',
        date: 'Answer date:',
        new: 'NEW',
    },
    Pagination: {
        min: 'Page number cannot be less than 1',
        max: (max: string | number) => `The page number cannot be greater than ${max}`,
        error: 'Please enter a valid value',
    },
    Panel: {
        permission: 'You are not authorized to view this page',
        pagePermission: 'This section is not available for your role',
    },
    PanelCalendar: {
        error: 'Failed to load calendar. Try again later.',
        updateError: 'Failed to update division position. Try again later.',
    },
    PanelCalendarActivation: {
        verification: 'Verification',
        materials: 'Materials',
        edit: 'Edit',
        activate: 'Activate',
        delivery: 'Delivery',
    },
    ProBadge: {
        label: 'PRO',
    },
    PanelCalendarHeader: {
        communityType: {
            all: 'All',
            beauty: 'Lorealistar',
            pro: 'Lorealistar PRO',
        },
        seeding: 'Seeding',
        tasks: 'Starting tasks',
        pushes: 'Pushes',
        seedingTooltip:
            'Number of seeding sent per week should <b>not be higher than 1500 packages</b>. If the number is higher please reach out to LOREALISTAR team to make sure you can proceed with your activation.',
        placeholder: 'Add new Activation placeholder',
    },
    PanelCalendarFooter: {
        label: 'Task status legend:',
        draft: 'Draft',
        placeholder: 'Placeholder',
        'waiting-for-approval': 'Waiting for approval',
        'approved-waiting-for-copy': 'Approved, waiting for copy',
        'approval-copy': 'Waiting for copy approval',
        'approved-with-all-documents': 'Approved with all documents',
        'request-for-improvement': 'Request for improvement',
        'seeding-verified': 'Seeding verified',
        'waiting-for-seeding-verification': 'Waiting for seeding verification',
    },
    PanelSummary: {
        button: 'Plan an activation',
        empty: 'No scheduled activations',
        seeding: 'Seeding',
        noSeeding: 'No seeding',
        todoTab: 'To do',
        calendarTab: 'Calendar',
    },
    PanelTodo: {
        empty: 'Nothing to do right now',
        error: 'Failed to load the to do list. Try again later.',
        task: {
            'placeholder-transition': 'Activation',
            products: 'Products',
            copy: 'Copy',
            po: 'PO',
            'rewards-step-1': 'Winners Step 1',
            'rewards-step-2': 'Winners Step 2',
        },
        deadline: {
            overdue: 'Overdue',
            today: 'Today',
            day: '1 day',
            days: (count: number) => `${count} days`,
        },
    },
    PanelHeader: {
        button: 'Plan an activation',
    },
    PasswordRecovery: {
        email: {
            label: 'E-mail address',
            error: {
                required: 'E-mail is required',
                email: 'The email address is invalid',
            },
            placeholder: 'haniakowalska@gmail.com',
        },
        submit: {
            label: 'Submit',
        },
    },
    PasswordReset: {
        error: 'Password reset failed. Try again later.',
    },
    PasswordResetForm: {
        newPassword: {
            label: 'New password',
            placeholder: '********',
            error: {
                min: 'Password must be at least 8 characters long',
                max: 'The password cannot be longer than 32 characters',
                required: 'A new password is required',
            },
        },
        repeatPassword: {
            label: 'Confirm password',
            placeholder: '********',
            error: {
                min: 'Password must be at least 8 characters long',
                max: 'The password cannot be longer than 32 characters',
                mustMatch: 'Passwords must be identical',
                required: 'You must confirm your password before submitting the form',
            },
        },
        token: {
            error: 'Bad authentication token.',
        },
        submit: {
            label: 'Submit',
        },
    },
    PriceChangeTable: {
        date: 'Change date',
        user: 'User',
        oldPrice: 'Old price',
        newPrice: 'New price',
        error: 'Failed to download the price change list',
    },
    Product: {
        title: 'Product details',
        details: 'Details',
        quantity: 'Product stock',
        history: 'Activation history',
        price: 'Price change',
        list: 'Back to product list',
    },
    ProductAdd: {
        mainTitle: 'Product inventory',
        title: 'Add product',
        list: 'Back to product list',
        ean: {
            label: 'EAN',
            required: 'EAN is required',
        },
        name: {
            label: 'Product name',
            required: 'Product name is required',
            info: 'This product name will be added to your task copy.',
        },
        image: {
            label: 'Product image',
            required: 'Image is required',
        },
        brand: {
            label: 'Brand',
            required: 'Brand is required',
        },
        size: {
            label: 'Product size',
            required: 'Size is required',
        },
        capacity: {
            label: 'Product capacity',
            required: 'Capacity is required',
        },
        price: {
            label: 'Market price (PLN)',
            required: 'Price is required',
        },
        tax: {
            label: 'Tax',
            required: 'Tax is required',
        },
        status: {
            label: 'Status',
            required: 'Status is required',
        },
        description: {
            label: 'Product description',
            required: 'Description is required',
            info: 'This product description will be added to your task copy.',
        },
        create: 'Save',
        success: 'Product created successfully',
        error: 'Failed to create a product. Try again later.',
    },
    ProductAddForm: {
        draftTitle: 'Create product draft',
        ean: {
            label: 'EAN',
            required: 'EAN is required',
        },
        name: {
            label: 'Product name',
            required: 'Product name is required',
            info: 'This product name will be added to your task copy.',
        },
        image: {
            label: 'Product image',
            required: 'Image is required',
        },
        brand: {
            label: 'Brand',
            required: 'Brand is required',
        },
        size: {
            label: 'Product size',
            required: 'Size is required',
        },
        capacity: {
            label: 'Product capacity',
            required: 'Capacity is required',
        },
        price: {
            label: 'Market price (PLN)',
            required: 'Price is required',
        },
        tax: {
            label: 'Tax',
            required: 'Tax is required',
        },
        status: {
            label: 'Status',
            required: 'Status is required',
        },
        description: {
            label: 'Product description',
            required: 'Description is required',
            info: 'This product description will be added to your task copy.',
        },
        comment: {
            label: 'Reason',
            required: 'Reason is required',
            info: 'Please provide a reason for adding this product draft',
        },
        create: 'Save',
        successAdd: 'Product created successfully',
        successEdit: 'Product updated successfully',
        errorAdd: 'Failed to create the product. Try again later.',
        errorEdit: 'Failed to update the product. Try again later.',
        errorDraftAdd: 'Failed to add new draft. Try again later.',
        errorDraftEdit: 'Failed to update this draft. Try again later.',
    },
    ProductData: {
        id: 'Product ID',
        ean: 'EAN',
        name: 'Name',
        brand: 'Brand',
        description: 'Description',
        image: 'Image',
        price: 'Price',
        tax: 'Tax',
        size: 'Size',
        capacity: 'Capacity',
        status: 'Status',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
    },
    ProductListing: {
        title: 'Products',
        products: 'Products',
        drafts: 'Drafts',
        import: 'Import',
        returns: 'Request returns',
    },
    ProductsList: {
        title: 'Products list',
        add: 'Add new product',
        error: 'Failed to download products. Try again later.',
        empty: 'The product list is empty',
        search: 'Search',
        filter: 'All',
    },
    ProductTable: {
        id: 'Id',
        image: 'Image',
        ean: 'EAN',
        name: 'Product name',
        brand: 'Brand',
        total: 'Total stock',
        available: 'Available stock',
        reservedPlanned: 'Reserved planned',
        reservedProgress: 'Reserved in progress',
        updated: 'Last update',
        status: 'Status',
        actions: 'Actions',
        details: 'Details',
        request: 'Request return',
        reason: 'Reason for import',
        createdAt: 'Submission date',
        accept: 'Accept',
        reject: 'Decline',
        accepted: 'The product has been accepted',
        acceptedError: 'Failed to accept the product. Try again later.',
        rejected: 'The product has been rejected',
        rejectedError: 'Failed to reject the product. Try again later.',
    },
    ProductsImport: {
        title: 'Product import',
        import: 'Import',
        file: {
            required: 'File is required',
        },
        success: 'Products imported successfully',
        error: 'Failed to import products list. Try again later.',
        export: 'Export products',
        exportError: 'Failed to export products list. Try again later.',
    },
    ProductSearchInput: {
        placeholder: 'Search for a product by EAN code',
        info: `Can't find a product?`,
        add: 'Add manually',
        searchError: 'Failed to fetch products. Try again later.',
        searchEmpty: 'Products list is empty.',
    },
    RadioGroup: {
        from: 'od',
        to: 'do',
        check: 'Zaznacz',
        valueFrom: 'Wartość od',
        valueTo: 'Wartość do',
        errors: {
            max: 'Wartość minimalna nie może być większa od maksymalnej.',
            value: 'Wartość',
            lower: 'nie może być mniejsza niż',
            higher: 'nie może być większa niż',
        },
    },
    RebrandModal: {
        title: 'Cześć! 💜',
        intro: 'Gotowi na nową erę? Beauty coLAB zmienia się w <span class="colored">LOREALISTAR</span>! ✨',
        description:
            'Świeża nazwa, nowa energia i jeszcze więcej powodów, by być częścią naszej społeczności. Wracamy w odświeżonej formie, przynosząc ze sobą mnóstwo zmian:',
        item1: '🏆 <b>Większe konkursy z nagrodami</b> – jeszcze więcej okazji, by zdobyć coś wyjątkowego!',
        item2: '🥂 <b>Dedykowane wydarzenia</b> – spotkania i warsztaty, które na długo zostaną w Waszej pamięci.',
        item3: '🧢 <b>Unikalne gadżety</b> – stylowe dodatki stworzone specjalnie dla Was.',
        item4: '📚 <b>Zaktualizowana baza wiedzy</b> – jeszcze więcej przydatnych informacji w jednym miejscu.',
        item5: '✨ <b>Odświeżony wygląd aplikacji</b> – aplikacja w zupełnie nowej odsłonie.',
        outro: 'Zmieniamy się dla Was, aby każda chwila z LOREALISTAR była pełna inspiracji. Bądźcie czujni – nadchodzą wielkie rzeczy! 💫',
    },
    RegisterModal: {
        confirm: 'Okej, rozumiem',
        title: 'Jak dołączyć do <span class="colored">LOREALI<b>STAR</b></span>?',
        item1: '<b>1.</b> Przeczytaj cały Regulamin.',
        item2: '<b>2.</b> Po dojściu do końca Regulaminu, zaznacz i zaakceptuj wymagane zgody.',
        item3: '<b>3.</b> Uzupełnij pozostałe dane.',
        item4: '<b>4.</b> Pamiętaj, że aby otrzymać dostęp do LOREALI<b>STAR</b> musisz mieć minimum 1000 obserwatorów na Instagramie, mieć skończone 18 lat i posiadać stały adres do wysyłki paczek w Polsce.',
        item5: '<b>5.</b> Kliknij w przycisk i wyślij swoje zgłoszenie do LOREALISTAR!',
        item6: '',
    },
    RegisterProModal: {
        confirm: 'Okej, rozumiem',
        title: 'Jak dołączyć do <span class="colored">LOREALI<b>STAR</b></span> lub <img alt="Logo" src="/images/logo-pro-violet.svg" style="display:inline-block;height:1.3em;vertical-align:-0.35em"/>?',
        item1: '<b>1.</b> Przeczytaj cały Regulamin.',
        item2: '<b>2.</b> Upewnij się, że wypełniasz formularz do odpowiedniej wersji platformy poprzez zaznaczenie LOREALI<b>STAR</b> lub <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.25em"/></span>.',
        item3: '<b>3.</b> Po dojściu do końca Regulaminu, zaznacz i zaakceptuj wymagane zgody.',
        item4: '<b>4.</b> Uzupełnij pozostałe dane.',
        item5: '<b>5.</b> Pamiętaj, że aby otrzymać dostęp do LOREALI<b>STAR</b> lub <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.25em"/></span> musisz mieć minimum 1000 obserwatorów na jednej z platform: Instagram, TikTok lub Youtube, mieć skończone 18 lat i posiadać stały adres do wysyłki paczek w Polsce.',
        item6: '<b>6.</b> Kliknij w przycisk i wyślij swoje zgłoszenie do LOREALISTAR lub <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.25em"/></span>!',
    },
    RegistrationForm: {
        firstName: {
            label: 'Imię',
            error: {
                required: 'Imię jest obowiązkowe',
            },
        },
        lastName: {
            label: 'Nazwisko',
            error: {
                required: 'Nazwisko jest obowiązkowe',
            },
        },
        email: {
            label: 'Email',
            error: {
                required: 'Email jest obowiązkowy',
                email: 'Wprowadź poprawny adres Email',
            },
        },
        password: {
            label: 'Hasło',
            error: {
                required: 'Hasło jest obowiązkowe',
                min: 'Hasło powinno mieć minimum 8 znaków',
                max: 'Hasło nie może być dłuższe niż 32 znaki',
            },
        },
        consent: {
            error: {
                required: 'Twoja zgoda jest wymagana',
            },
        },
        submit: {
            label: 'Utwórz konto',
        },
    },
    RequestReturns: {
        title: 'Request returns',
        error: 'Failed to download request returns. Try again later.',
        empty: 'List is empty.',
        id: 'ID',
        product: 'Product',
        ean: 'EAN',
        address: 'Address',
        quantity: 'Quantity',
        recipient: 'Recipient',
        status: 'Status',
        cancel: 'Cancel',
        finish: 'Finish',
        cancelError: 'Failed to cancel this request. Try again later.',
        finishError: 'Failed to finish this request. Try again later.',
        cancelSuccess: 'Request has been canceled',
        finishSuccess: 'Request has been finished',
    },
    RequestReturnModal: {
        title: 'Request return',
        subtitle: 'How many products should we send back?',
        available: 'Available quantity:',
        quantity: {
            label: (count: string | number) => `Available quantity: ${count}`,
            placeholder: 'Fill',
            required: 'Quantity is required',
            info: 'Number greater than 1 but equal or less than available',
            max: (max: number) => `Quantity must be between 1 and ${max}`,
        },
        recipient: {
            label: "Recipient's name",
            placeholder: 'Fill',
            required: "Recipient's name is required",
        },
        address: {
            label: 'Return address',
            required: 'Address is required',
        },
        submit: 'Return',
        success: 'Return request has been submitted successfully.',
        error: 'Failed to send the return request. Try again later.',
    },
    RTKQueryApi: {
        errors: {
            FETCH_ERROR: 'Wystąpił problem podczas wysyłania żądania',
            PARSING_ERROR: 'Wystąpił problem podczas przetwarzania odpowiedzi żądania',
            TIMEOUT_ERROR: 'Czas na zapytanie został przekroczony',
            CUSTOM_ERROR: 'Wystąpił nieznany błąd',
        },
    },
    QuestionnaireApplication: {
        unfold: 'Read more',
        fold: 'Collapse',
        answer: 'Answer date:',
        new: 'NEW',
    },
    SearchBar: {
        inputPlaceholder: 'Search...',
    },
    SearchDropdown: {
        categoryTitle: 'Kategorie',
        productsTitle: 'Produkty',
        seeAllProducts: 'Zobacz wszystkie produkty',
    },
    SearchInput: {
        name: 'Search',
        clearButton: 'Clear',
    },
    Select: {
        defaultPlaceholder: 'Select...',
        defaultNoOptions: 'No options',
    },
    SignUp: {
        title: 'Cieszymy się, że chcesz dołączyć do <span class="colored">Loreali<b>STAR</b>!</span>',
        subtitle: 'REJESTRACJA',
        description1:
            "Dołącz do unikalnej aplikacji stworzonej przez grupę L'Oréal specjalnie dla influencerów. Aby zawnioskować o dołączenie, jest nam potrzebnych kilka informacji o Tobie.",
        description2: 'Wybierz program, do którego chcesz się zapisać:',
        descriptionBottom:
            'Przeczytaj Regulamin, zaakceptuj wymagane zgody, a następnie uzupełnij swoje dane – zajmie to tylko chwilę!',
        annotation: 'Dziękujemy za wybór <span class="colored">LorealiSTAR</span>!',
        error: {
            network: 'Wystąpił problem z siecią',
            global: 'Wystąpił błąd. Spróbuj ponownie później',
            rules: 'Nie udało się pobrać regulaminu. Przepraszamy.',
        },
        rules: 'Regulamin',
        rulesNotice:
            'Aby wypełnić formularz rejestracji, najpierw zapoznaj się z Regulaminem – przewiń go do końca w oknie poniżej.',
        rulesNoticeRead:
            'Dziękujemy za zapoznanie się z Regulaminem. Możesz teraz wypełnić formularz rejestracji poniżej.',
        companyName: 'LOREALISTAR',
        previousRules: 'Poprzednie Regulaminy',
        footer: 'Po uzupełnieniu formularza, wyślij swoje zgłoszenie. Twoje odpowiedzi zostaną sprawdzone w ciągu <span class="bold">5 dni roboczych.</span> O wynikach weryfikacji poinformujemy Cię w DM na Instagramie lub w wiadomości na adres e-mail podany w formularzu. Aby zapewnić Ci stały dostęp do Regulaminu LorealiSTAR i zagwarantować transparentność, po wysłaniu formularza dokument zostanie automatycznie pobrany na Twoje urządzenie.',
    },
    SignUpPro: {
        title: 'Cieszymy się, że chcesz dołączyć do <img alt="Logo" src="/images/logo-pro-violet.svg" style="display:inline-block;height:1.3em;vertical-align:-0.35em"/>!</span>',
        subtitle: 'REJESTRACJA',
        description1:
            "Dołącz do unikalnej aplikacji stworzonej przez grupę L'Oréal specjalnie dla influencerów. Aby zawnioskować o dołączenie, jest nam potrzebnych kilka informacji o Tobie.",
        description2: 'Wybierz program, do którego chcesz się zapisać:',
        descriptionBottom:
            'Przeczytaj Regulamin, zaakceptuj wymagane zgody, a następnie uzupełnij swoje dane – zajmie to tylko chwilę!',
        annotation:
            'Dziękujemy za wybór <img alt="Logo" src="/images/logo-pro-violet.svg" style="display:inline-block;height:1.3em;vertical-align:-0.35em; max-width: fit-content"/> !</span>',
        error: {
            network: 'Wystąpił problem z siecią',
            global: 'Wystąpił błąd. Spróbuj ponownie później',
            rules: 'Nie udało się pobrać regulaminu. Przepraszamy.',
        },
        rules: 'Regulamin',
        rulesNotice:
            'Aby wypełnić formularz rejestracji, najpierw zapoznaj się z Regulaminem – przewiń go do końca w oknie poniżej.',
        rulesNoticeRead:
            'Dziękujemy za zapoznanie się z Regulaminem. Możesz teraz wypełnić formularz rejestracji poniżej.',
        companyName:
            '<span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.25em"/></span>',
        previousRules: 'Poprzednie Regulaminy',
        footer: 'Po uzupełnieniu formularza, wyślij swoje zgłoszenie. Twoje odpowiedzi zostaną sprawdzone w ciągu <span class="bold">5 dni roboczych.</span> O wynikach weryfikacji poinformujemy Cię w DM na Instagramie lub w wiadomości na adres e-mail podany w formularzu. Aby zapewnić Ci stały dostęp do Regulaminu <span><img alt="Logo" src="/images/logo-pro.svg" style="display:inline-block;height:1.3em;vertical-align:-0.3em"/></span>! i zagwarantować transparentność, po wysłaniu formularza dokument zostanie automatycznie pobrany na Twoje urządzenie.',
    },
    SignIn: {
        email: 'E-mail address',
        password: 'Password',
        recover: 'Forgot your password?',
        link: 'Password recovery',
    },
    ShippingAddressModal: {
        text: 'Jeśli przystępujesz do LOREALISTAR w związku z prowadzoną działalnością gospodarczą to Ewentualne nagrody stanowią dochód z tej działalności, podlegają opodatkowaniu jak inne dochody z działalności gospodarczej i wymagają od Ciebie właściwego rozliczenia podatkowego.<br/><b>Pamiętaj o rozliczeniu.</b>',
    },
    StockHistoryTable: {
        title: 'Stock History',
        date: 'Date',
        quantity: 'Quantity change',
        quantityTotal: 'New quantity',
        source: 'Change source',
        comment: 'Additional comments',
        user: 'User',
        error: 'Failed to download the stock history',
    },
    TaskApplicationCommentModal: {
        save: 'Save',
        title: 'Comment',
        placeholder: 'Enter your comment',
    },
    TasksPanel: {
        error: 'An error occurred and the data could not be loaded.',
    },
    Toast: {
        closeButton: 'Close',
    },
    TodaysSummary: {
        title: "Today's Summary",
        tasks: 'Tasks',
        pushes: 'Pushes',
        verifications: 'Verifications',
        materials: 'Materials for verification',
        seedings: 'Seedings',
        thisWeek: 'This week',
        error: 'An error occurred and the data could not be loaded.',
    },
    ThankYouTemplate: {
        title: 'Thank You!',
        content:
            'You activation copy has been sent to the LOREALISTAR team for verification. If there are any changes needed, you will be notified. Please remember to check your activation status.',
        button: 'Go to activation details',
    },
    UpdateQuantity: {
        title: 'Update quantity',
        type: {
            label: 'Type of operation',
            required: 'Type of operation is required',
        },
        quantity: {
            label: 'Quantity',
            required: 'Quantity is required',
        },
        comment: {
            label: 'Comments (opcjonalnie)',
        },
        save: 'Save changes',
        info: {
            total: 'Total stock',
            available: 'Available stock',
            reservedPlanned: 'Reserved planned',
            reservedInProgress: 'Reserved in progress',
            update: 'Last update',
        },
        update: {
            title: 'Update stock',
            type: 'Operation type',
            quantity: 'Quantity',
            source: 'Change source',
            comment: 'Additional comments',
            placeholder: 'Fill',
            button: 'Update stock',
            successEdit: 'Product quantity updated successfully',
            errorEdit: 'Failed to update the product quantity. Try again later.',
        },
    },
    UpwardsButton: {
        up: 'Do góry',
    },
    UseBudget: {
        brand: 'Brand',
        year: 'Year',
        label: {
            cdmo: 'CDMO budget split by conso %',
            brand: 'Brand budget',
        },
    },
    UseLanguageConfig: {
        pl: 'Polski',
        en: 'Angielski',
    },
    VerificationFinishModal: {
        title: 'Are you sure you want to <span>finish</span> verification?',
        description: "Verification will be finished immediately. You can't undo this action",
        cancel: 'Cancel',
        delete: 'Yes, finish',
    },
} as const;

export default pl;
